const markets = [
    // Americas
    {
        country: "united states",
        countryCode: "US",
        countryCode3: "USA",
        catalogType: "Enroll",
        externalSite: false,
        zipLength: [5, 9],
        region: "americas",
        dateFormat: "MDY",

        languages: [
            {
                code: "en",
                externalLink: null
                //externalLink: "https://shop.unicity.com/?country=US&wid=25&currency=USD&code=en"
            },
            {
                code: "es",
                externalLink: null
                //externalLink: "https://shop.unicity.com/?country=US&wid=25&currency=USD&code=es"
            }
        ]
    },
    {
        country: "canada",
        countryCode: "CA",
        countryCode3: "CAN",
        catalogType: "Enroll",
        zipLength: 6,
        externalSite: false,
        region: "americas",
        dateFormat: "MDY",
        languages: [
            {
                code: "en",
                externalLink: null
            },
            {
                code: "fr",
                externalLink: null
            }
        ]
    },
    {
        country: "dominican republic",
        countryCode: "DO",
        countryCode3: "DOM",
        zipLength: 5,
        externalSite: false,
        region: "americas",
        dateFormat: "MDY",
        languages: [
            {
                code: "es",
                externalLink: null
            }
        ]
    },
    {
        country: "colombia",
        countryCode: "CO",
        countryCode3: "COL",
        zipLength: 6,
        externalSite: false,
        region: "americas",
        dateFormat: "MDY",
        languages: [
            {
                code: "es",
                externalLink: null
            }
        ]
    },
    {
        country: "bahamas",
        countryCode: "BS",
        countryCode3: "BHS",
        catalogType: "Enroll",
        zipLength: 6,
        shippingLength: 60,
        externalSite: false,
        phoneLength: 10,
        region: "americas",
        dateFormat: "MDY",
        languages: [
            {
                code: "en",
                externalLink: null
            }
        ]
    },
    /*{
  country: "dominica",
  countryCode: "DM",
  zipLength: 5,
  externalSite: false,
  languages: [
    {
      code: "en",
      externalLink: null
    }
  ]
},*/
    {
        country: "mexico",
        countryCode: "MX",
        countryCode3: "MEX",
        zipLength: 5,
        externalSite: false,
        region: "americas",
        dateFormat: "MDY",
        languages: [
            {
                code: "es",
                externalLink: null
            }
        ]
    },
    {
        country: "puerto rico",
        countryCode: "PR",
        countryCode3: "PRI",
        shipsTo: { country: "US", state: "PR" },
        zipLength: 5,
        externalSite: false,
        region: "americas",
        dateFormat: "MDY",
        languages: [
            {
                code: "en",
                externalLink: null
            },
            {
                code: "es",
                externalLink: null
            }
        ]
    },
    // EU
    {
        country: "united kingdom",
        countryCode: "GB",
        countryCode3: "GBR",
        zipLength: [5, 6, 7],
        externalSite: false,
        region: "europe",
        hasPrivacyPolicy: true,
        hasLongTermsConditions: true,
        dateFormat: "DMY",
        languages: [
            {
                code: "en",
                externalLink: null
            }
        ]
    },
    // {
    //     country: 'austria',
    //     countryCode: 'AT',
    //     externalSite: false,
    //     zipLength: 4,
    //     region: 'europe',
    //     languages: [
    //         {
    //             code: 'de',
    //             externalLink: null,
    //         },
    //         {
    //             code: 'en',
    //             externalLink: null,
    //         },
    //     ],
    // },
    // {
    //     country: 'denmark',
    //     countryCode: 'DK',
    //     externalSite: false,
    //     zipLength: 4,
    //     region: 'europe',
    //     languages: [
    //         {
    //             code: 'en',
    //             externalLink: null,
    //         },
    //         {
    //             code: 'da',
    //             externalLink: null,
    //         },
    //     ],
    // },

    // {
    //     country: 'belgium',
    //     countryCode: 'BE',
    //     externalSite: false,
    //     zipLength: 4,
    //     region: 'europe',
    //     languages: [
    //         {
    //             code: 'en',
    //         },
    //         {
    //             code: 'fr',
    //         },
    //         {
    //             code: 'nl',
    //         },
    //     ],
    // },
    // {
    //     country: 'hungary',
    //     countryCode: 'HU',
    //     zipLength: 4,
    //     externalSite: false,
    //     region: 'europe',
    //     languages: [
    //         {
    //             code: 'en',
    //             externalLink: null,
    //         },
    //         {
    //             code: 'hu',
    //             externalLink: null,
    //         },
    //     ],
    // },

    // {
    //     country: 'france',
    //     countryCode: 'FR',
    //     zipLength: 5,
    //     externalSite: false,
    //     region: 'europe',
    //     languages: [
    //         {
    //             code: 'fr',
    //             externalLink: null,
    //         },
    //         {
    //             code: 'en',
    //             externalLink: null,
    //         },
    //     ],
    // },
    // {
    //     country: 'germany',
    //     countryCode: 'DE',
    //     zipLength: 5,
    //     externalSite: false,
    //     region: 'europe',
    //     languages: [
    //         {
    //             code: 'de',
    //             externalLink: null,
    //         },
    //         {
    //             code: 'en',
    //             externalLink: null,
    //         },
    //     ],
    // },
    // {
    //     country: 'ireland',
    //     countryCode: 'IE',
    //     zipLength: [1, 2, 3, 4, 5, 6, 7, 8],
    //     externalSite: false,
    //     region: 'europe',
    //     languages: [
    //         {
    //             code: 'en',
    //             externalLink: null,
    //         },
    //     ],
    // },
    // {
    //     country: 'italy',
    //     countryCode: 'IT',
    //     zipLength: 5,
    //     externalSite: false,
    //     region: 'europe',
    //     languages: [
    //         {
    //             code: 'en',
    //             externalLink: null,
    //         },
    //         {
    //             code: 'it',
    //             externalLink: null,
    //         },
    //     ],
    // },
    // {
    //     country: 'netherlands',
    //     countryCode: 'NL',
    //     zipLength: 6,
    //     externalSite: false,
    //     region: 'europe',
    //     languages: [
    //         {
    //             code: 'en',
    //             externalLink: null,
    //         },
    //         {
    //             code: 'nl',
    //             externalLink: null,
    //         },
    //     ],
    // },
    // {
    //     country: 'poland',
    //     countryCode: 'PL',
    //     zipLength: 6,
    //     externalSite: false,
    //     region: 'europe',
    //     languages: [
    //         {
    //             code: 'en',
    //             externalLink: null,
    //         },
    //         {
    //             code: 'pl',
    //             externalLink: null,
    //         },
    //     ],
    // },
    // {
    //     country: 'norway',
    //     countryCode: 'NO',
    //     zipLength: 4,
    //     externalSite: false,
    //     region: 'europe',
    //     languages: [
    //         {
    //             code: 'en',
    //             externalLink: null,
    //         },
    //         {
    //             code: 'nb',
    //             externalLink: null,
    //         },
    //     ],
    // },
    // {
    //     country: 'sweden',
    //     countryCode: 'SE',
    //     zipLength: 5,
    //     externalSite: false,
    //     region: 'europe',
    //     languages: [
    //         {
    //             code: 'en',
    //             externalLink: null,
    //         },
    //         {
    //             code: 'sv',
    //             externalLink: null,
    //         },
    //     ],
    // },
    {
        country: "switzerland",
        countryCode: "CH",
        countryCode3: "CHE",
        zipLength: 4,
        externalSite: false,
        region: "europe",
        hasPrivacyPolicy: true,
        hasLongTermsConditions: true,
        dateFormat: "DMY",
        languages: [
            {
                code: "de",
                externalLink: null
            },
            {
                code: "fr",
                externalLink: null
            },
            {
                code: "en",
                externalLink: null
            }
        ]
    },
    // {
    //     country: 'ukraine',
    //     countryCode: 'UA',
    //     zipLength: 5,
    //     externalSite: false,
    //     region: 'europe',
    //     languages: [
    //         {
    //             code: 'en',
    //             externalLink: null,
    //         },
    //         {
    //             code: 'ru',
    //             externalLink: null,
    //         },
    //     ],
    // },
    // {
    //     country: 'luxembourg',
    //     countryCode: 'LU',
    //     zipLength: 4,
    //     externalSite: false,
    //     region: 'europe',
    //     languages: [
    //         {
    //             code: 'fr',
    //             externalLink: null,
    //         },
    //         {
    //             code: 'de',
    //             externalLink: null,
    //         },
    //         {
    //             code: 'en',
    //             externalLink: null,
    //         },
    //     ],
    // },
    // {
    //     country: 'spain',
    //     countryCode: 'ES',
    //     zipLength: 5,
    //     externalSite: false,
    //     region: 'europe',
    //     languages: [
    //         {
    //             code: 'en',
    //             externalLink: null,
    //         },
    //         {
    //             code: 'es',
    //             externalLink: null,
    //         },
    //     ],
    // },
    // Asia Pacific
    {
        country: "australia",
        countryCode: "AU",
        countryCode3: "AUS",
        externalSite: false,
        zipLength: 4,
        region: "asiapacific",
        languages: [
            {
                code: "en",
                externalLink: null
            }
        ]
    },
    {
        country: "new zealand",
        countryCode: "NZ",
        countryCode3: "NZL",
        zipLength: 4,
        externalSite: false,
        region: "asiapacific",
        dateFormat: "DMY",
        languages: [
            {
                code: "en",
                externalLink: null
            }
        ]
    },
    {
        country: "india",
        countryCode: "IN",
        countryCode3: "IND",
        zipLength: 6,
        shippingLength: 60,
        externalSite: false,
        region: "asiapacific",
        phoneLength: 10,
        languages: [
            {
                code: "en",
                externalLink: null
            },
            {
                code: "hi",
                // name: 'हिन्दी',
                externalLink: null
            }
        ]
    },
    {
        country: "singapore",
        countryCode: "SG",
        countryCode3: "SGP",
        region: "asiapacific",
        externalSite: false,
        languages: [
            {
                code: "en",
                externalLink: null
            }
        ]
    },
    {
        country: "phillipines",
        countryCode: "PH",
        countryCode3: "PHL",
        region: "asiapacific",
        zipLength: 4,
        externalSite: false,
        languages: [
            {
                code: "en",
                externalLink: null
            }
        ]
    },
    {
        country: "malaysia",
        countryCode: "MY",
        countryCode3: "MYS",
        region: "asiapacific",
        zipLength: 5,
        externalSite: false,
        languages: [
            {
                code: "en",
                externalLink: null
            }
        ]
    },
    {
        country: "brunei darussalam",
        countryCode: "BN",
        countryCode3: "BRN",
        region: "asiapacific",
        zipLength: 6,
        externalSite: false,
        languages: [
            {
                code: "en",
                externalLink: null
            }
        ]
    },
    {
        country: "hong kong",
        countryCode: "HK",
        countryCode3: "HKG",
        region: "asiapacific",
        zipLength: 6,
        externalSite: false,
        languages: [
            {
                code: "en",
                externalLink: null
            },
            {
                code: "zh",
                externalLink: null
            }
        ]
    },
    {
        country: "taiwan",
        countryCode: "TW",
        countryCode3: "TWN",
        region: "asiapacific",
        zipLength: 3,
        externalSite: false,
        languages: [
            {
                code: "en",
                externalLink: null
            },
            {
                code: "zh",
                externalLink: null
            }
        ]
    },
    // {
    //     country: "indonesia",
    //     countryCode: "ID",
    //     countryCode3: "IDN",
    //     region: "asiapacific",
    //     zipLength: 6,
    //     shippingLength: 60,
    //     externalSite: false,
    //     phoneLength: 10,
    //     languages: [
    //         {
    //             code: "en",
    //             externalLink: null
    //         },
    //         {
    //             code: "id",
    //             externalLink: null
    //         }
    //     ]
    // },
    // Middle East and Africa
    {
        country: "oman",
        countryCode: "OM",
        countryCode3: "OMN",
        zipLength: 5,
        externalSite: false,
        region: "middleeastandafrica",
        languages: [
            {
                code: "en",
                externalLink: null
            }
        ]
    },
    {
        country: "morocco",
        countryCode: "MA",
        countryCode3: "MAR",
        zipLength: 5,
        externalSite: false,
        region: "middleeastandafrica",
        languages: [
            {
                code: "en",
                externalLink: null
            },
            {
                code: "fr",
                externalLink: null
            }
        ]
    },
    {
        country: "egypt",
        countryCode: "EG",
        countryCode3: "EGY",
        zipLength: 5,
        externalSite: false,
        region: "middleeastandafrica",
        languages: [
            {
                code: "en",
                externalLink: null
            }
            // {
            //     code: "ar",
            //     externalLink: null
            // }
        ]
    },
    {
        country: "bahrain",
        countryCode: "BH",
        countryCode3: "BHR",
        zipLength: 5,
        externalSite: false,
        region: "middleeastandafrica",
        languages: [
            {
                code: "en",
                externalLink: null
            }
            // {
            //     code: "ar",
            //     externalLink: null
            // }
        ]
    },
    {
        country: "turkey",
        countryCode: "TR",
        countryCode3: "TUR",
        zipLength: 5,
        externalSite: false,
        region: "middleeastandafrica",
        dateFormat: "DMY",
        languages: [
            {
                code: "en",
                externalLink: null
            },
            {
                code: "tr",
                externalLink: null
            }
        ]
    },
    {
        country: "algeria",
        countryCode: "DZ",
        countryCode3: "DZA",
        zipLength: 5,
        externalSite: false,
        region: "middleeastandafrica",
        languages: [
            {
                code: "en",
                externalLink: null
            },
            {
                code: "fr",
                externalLink: null
            }
            // {
            //     code: "ar",
            //     externalLink: null
            // }
        ]
    },
    {
        country: "jordan",
        countryCode: "JO",
        countryCode3: "JOR",
        zipLength: 5,
        externalSite: false,
        region: "middleeastandafrica",
        languages: [
            {
                code: "en",
                externalLink: null
            }
        ]
    },
    {
        country: "united arab emirates",
        countryCode: "AE",
        countryCode3: "ARE",
        zipLength: 5,
        externalSite: false,
        region: "middleeastandafrica",
        languages: [
            {
                code: "en",
                externalLink: null
            }
            // {
            //     code: "ar",
            //     externalLink: null
            // }
        ]
    }
    /*
  {
      country: 'thailand',
      countryCode: 'TH',
      countryCode3: 'THA',
      externalSite: false,
      region: 'asiapacific',
      languages: [
          {
              code: 'en',
              externalLink: null,
          },
          {
              code: 'th',
              name: 'ไทย',
              externalLink: null,
          },
      ],
  },
{
  country: "japan",
  countryCode: "JP",
  countryCode3: "JPN",
  externalSite: false,
  languages: [
    {
      code: "en"
    },
    {
      code: "ja"
    }
  ]
},
{
  country: "korea",
  countryCode: "KR",
  countryCode3: "KOR",
  externalSite: true,
  languages: [
    {
      code: "en",
      externalLink:
        "https://secure.unicity.net/unicitykor/ShoppingCart/Shop.cfm?&Theme=Default&Country=KOR"
    }
  ]
},


{
  country: "ukraine",
  countryCode: "UA",
  zipLength: 5,
  externalSite: false,
  languages: [
    {
      code: "en",
      externalLink: null
    },
    {
      code: "ru",
      externalLink: null
    }
  ]
},
{
  country: "belgium",
  countryCode: "BE",
  externalSite: false,
  zipLength: 4,
  languages: [
    {
      code: "fr"
    },
    {
      code: "en"
    },
    {
      code: "nl"
    }
  ]
},
{
  country: "hungary",
  countryCode: "HU",
  zipLength: 4,
  externalSite: false,
  languages: [
    {
      code: "hu",
      externalLink: null
    },
    {
      code: "en",
      externalLink: null
    }
  ]
},

{
  country: "trinidad and tobago",
  countryCode: "TT",
  catalogType: "Enroll",
  zipLength: 6,
  shippingLength: 60,
  externalSite: false,
  phoneLength: 10,
  languages: [
    {
      code: "en",
      externalLink: null
    }
  ]
},
{
  country: "grenada",
  countryCode: "GD",
  catalogType: "Enroll",
  zipLength: 6,
  shippingLength: 60,
  externalSite: false,
  phoneLength: 10,
  languages: [
    {
      code: "en",
      externalLink: null
    }
  ]
},
{
  country: "guyana",
  countryCode: "GY",
  catalogType: "Enroll",
  zipLength: 6,
  shippingLength: 60,
  externalSite: false,
  phoneLength: 10,
  languages: [
    {
      code: "en",
      externalLink: null
    }
  ]
},
{
  country: "bon air",
  countryCode: "BQ",
  catalogType: "Enroll",
  zipLength: 6,
  shippingLength: 60,
  externalSite: false,
  phoneLength: 10,
  languages: [
    {
      code: "en",
      externalLink: null
    }
  ]
},
{
  country: "anguilla",
  countryCode: "AI",
  catalogType: "Enroll",
  zipLength: 6,
  shippingLength: 60,
  externalSite: false,
  phoneLength: 10,
  languages: [
    {
      code: "en",
      externalLink: null
    }
  ]
},
{
  country: "curacao",
  countryCode: "CW",
  catalogType: "Enroll",
  zipLength: 6,
  shippingLength: 60,
  externalSite: false,
  phoneLength: 10,
  languages: [
    {
      code: "en",
      externalLink: null
    }
  ]
},
{
  country: "USVI",
  countryCode: "VI",
  catalogType: "Enroll",
  zipLength: 6,
  shippingLength: 60,
  externalSite: false,
  phoneLength: 10,
  languages: [
    {
      code: "en",
      externalLink: null
    }
  ]
},
{
  country: "turks & caico",
  countryCode: "TC",
  catalogType: "Enroll",
  zipLength: 6,
  shippingLength: 60,
  externalSite: false,
  phoneLength: 10,
  languages: [
    {
      code: "en",
      externalLink: null
    }
  ]
},
{
  country: "barbados",
  countryCode: "BB",
  catalogType: "Enroll",
  zipLength: 6,
  shippingLength: 60,
  externalSite: false,
  phoneLength: 10,
  languages: [
    {
      code: "en",
      externalLink: null
    }
  ]
},*/
    /*{
  country: "jamaica",
  countryCode: "JM",
  externalSite: false,
  languages: [
    {
      code: "en",
      externalLink: null
    }
  ]
},
{
  country: "indonesia",
  countryCode: "ID",
  countryCode3: "IDN",
  zipLength: 6,
  shippingLength: 60,
  externalSite: false,
  phoneLength: 10,
  languages: [
    {
      code: "en",
      externalLink: null
    },
    {
      code: "id",
      externalLink: null
    }
  ]
}*/
];
export default markets;



// WEBPACK FOOTER //
// ./src/services/markets/marketsList.js